import { StyleSheet } from 'react-native';

/**
 * Оформление окон органайзера: напоминания, отложенные сообщения, поздравление.
 *
 * <p>Цвета записаны здесь, а не берутся из `ConversationPalette`, — по той же причине, что и
 * у редактора заметки (`chatScreenStyles`): это модальные окна поверх затемнения, а не части
 * переписки. Тёмная карточка одинакова во всех темах, и в этом смысл — она не спорит с фоном,
 * каким бы он ни был, включая обои-фотографию.
 *
 * <p>Отдельным файлом на три окна, а не копией в каждом: три почти одинаковых набора цифр
 * разъезжаются на первой же правке отступов, и заметно это становится только на устройстве.
 */
export const organizerStyles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.45)',
    justifyContent: 'center',
    paddingHorizontal: 18,
  },
  card: {
    backgroundColor: 'rgba(30, 41, 59, 0.98)',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: 'rgba(148, 163, 184, 0.35)',
    padding: 14,
    gap: 12,
    maxWidth: 560,
    width: '100%',
    alignSelf: 'center',
    // Потолок обязателен: карточка отцентрована по вертикали, и без него длинный список
    // растягивает её на весь экран, выдавливая нижние кнопки под клавиатуру.
    maxHeight: '88%',
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  title: { color: 'rgba(226, 232, 240, 0.95)', fontSize: 16, fontWeight: '700' },
  sectionLabel: { color: 'rgba(148, 163, 184, 0.95)', fontSize: 12, fontWeight: '700' },
  hint: { color: 'rgba(148, 163, 184, 0.85)', fontSize: 12 },
  error: { color: '#fca5a5', fontSize: 13 },
  input: {
    backgroundColor: '#0f172a',
    borderRadius: 12,
    padding: 12,
    color: '#f8fafc',
    borderWidth: 1,
    borderColor: '#334155',
  },
  multiline: { minHeight: 84, maxHeight: 160 },
  row: { flexDirection: 'row', alignItems: 'center', gap: 8 },
  rowWrap: { flexDirection: 'row', flexWrap: 'wrap', gap: 8 },
  /** Половина строки: два поля «дата» и «время» рядом, а не одно под другим. */
  half: { flex: 1 },
  chip: {
    borderRadius: 999,
    borderWidth: 1,
    borderColor: 'rgba(148, 163, 184, 0.45)',
    paddingHorizontal: 12,
    paddingVertical: 7,
  },
  chipActive: {
    borderColor: 'rgba(96, 165, 250, 0.9)',
    backgroundColor: 'rgba(37, 99, 235, 0.30)',
  },
  chipText: { color: 'rgba(226, 232, 240, 0.92)', fontSize: 12, fontWeight: '600' },
  primaryBtn: {
    backgroundColor: 'rgba(37, 99, 235, 0.92)',
    borderRadius: 12,
    paddingHorizontal: 14,
    paddingVertical: 11,
    alignItems: 'center',
  },
  primaryBtnDisabled: { opacity: 0.5 },
  primaryBtnText: { color: '#fff', fontWeight: '700' },
  ghostBtn: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(148, 163, 184, 0.45)',
    paddingHorizontal: 14,
    paddingVertical: 11,
    alignItems: 'center',
  },
  ghostBtnText: { color: 'rgba(226, 232, 240, 0.92)', fontWeight: '600' },
  dangerText: { color: '#fca5a5', fontWeight: '600' },
  list: { flexGrow: 0, flexShrink: 1 },
  listItem: {
    backgroundColor: '#0f172a',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#334155',
    padding: 12,
    gap: 6,
    marginBottom: 8,
  },
  listItemTitle: { color: '#f8fafc', fontSize: 15, fontWeight: '600' },
  listItemMeta: { color: 'rgba(148, 163, 184, 0.9)', fontSize: 12 },
  empty: { color: 'rgba(148, 163, 184, 0.9)', textAlign: 'center', paddingVertical: 16 },
  /**
   * Выпадающий список поиска контактов. Не «поверх» формы (absolute), а в потоке: перекрытие
   * внутри и без того прокручиваемой карточки даёт две наложенные прокрутки, из которых
   * пальцем не выбраться — на телефоне это заметно сразу, а на мыши никогда.
   */
  dropdown: {
    marginTop: 6,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#334155',
    backgroundColor: '#0f172a',
    overflow: 'hidden',
  },
  dropdownRow: {
    paddingVertical: 12,
    paddingHorizontal: 12,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(51, 65, 85, 0.6)',
  },
  dropdownRowText: { color: '#e2e8f0', fontSize: 15 },
  dropdownRowTextActive: { color: '#93c5fd', fontWeight: '700' },
  dropdownClose: { alignItems: 'center', paddingVertical: 10 },
});
